module.exports = __webpack_public_path__ + "static/media/live.8ba44db8.svg";